import { Card, Empty, Spin, Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'
import { useState } from 'react'

import tableStore from '../../lib/store/review_table'
import ReviewService from '../../network/services/reviews'
import { serialize } from '../../network/request'
import ReviewTable from './ReviewTable'
import CreateReviewModal from './CreateReviewModal'
import { PageHeader } from '@ant-design/pro-layout'
import appClientStore from '../../lib/store/appClient'
import { useTranslation } from 'react-i18next'

const ReviewPage = () => {
  const { t } = useTranslation()
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

  const handleCreateSuccess = () => {
    // Trigger a refresh of the review table
    tableStore.state.refresh = Math.random()
  }

  return (
    <PageHeader
      title={t('reviews')}
      extra={[
        <Button
          key='create-review'
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => setIsCreateModalOpen(true)}
        >
          {t('createReview')}
        </Button>,
      ]}
    >
      <Card>
        <ReviewTableWrapper />
      </Card>
      <CreateReviewModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleCreateSuccess}
      />
    </PageHeader>
  )
}

const ReviewTableWrapper = () => {
  const {
    state: { id: appClientId },
  } = useSnapshot(appClientStore)
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(ReviewService.getAll(appClientId!), {
      page: state.currentPage,
      limit: state.pageSize,
      sort: state.sort ?? 'created_at:desc',
      refresh: state.refresh,
      ...state.filters,
    })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = ReviewService.toPaginate(response)

  return (
    <>
      <ReviewTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <ReviewTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default ReviewPage
